var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M75 512h167V330h-60v-60h60v-75a75 75 0 0 1 75-75h75v60h-60a30 30 0 0 0-30 30v60h87.3l-10 60H302v182h135a75 75 0 0 0 75-75V75a75 75 0 0 0-75-75H75A75 75 0 0 0 0 75v362a75 75 0 0 0 75 75zM30 75a45 45 0 0 1 45-45h362a45 45 0 0 1 45 45v362a45 45 0 0 1-45 45H332V360h72.7l20-120H332v-30h90V90H317c-57.9 0-105 47.1-105 105v45h-60v120h60v122H75a45 45 0 0 1-45-45zm0 0"
})));

export default SvgFacebook;